import * as React from 'react';

import ConsumerPageHeaderBffProvider from 'bundles/composable-page-header-consumer/providers/ConsumerPageHeaderBffProvider';
import ShoppingCartProvider from 'bundles/composable-page-header-consumer/providers/ShoppingCartProvider';

const DefaultConsumerPageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConsumerPageHeaderBffProvider>
      <ShoppingCartProvider>{children}</ShoppingCartProvider>
    </ConsumerPageHeaderBffProvider>
  );
};

export default DefaultConsumerPageHeaderProvider;
